// Courier services used for incoming shipments + their tracking-page URL builders.
// The tracking number is always displayed/copyable; the "Track" link opens the
// carrier's tracking page (deep-linked with the number where the carrier supports it).
export const CARRIERS = [
  { key: "Aramex", label: "Aramex", url: (n) => `https://www.aramex.com/track/results?ShipmentNumber=${encodeURIComponent(n)}` },
  { key: "CouriersPlease", label: "CouriersPlease", url: (n) => `https://www.couriersplease.com.au/tools-track/no/${encodeURIComponent(n)}` },
  { key: "DHL", label: "DHL", url: (n) => `https://www.dhl.com/au-en/home/tracking.html?tracking-id=${encodeURIComponent(n)}` },
  { key: "FedEx", label: "FedEx", url: (n) => `https://www.fedex.com/fedextrack/?trknbr=${encodeURIComponent(n)}` },
  { key: "UPS", label: "UPS", url: (n) => `https://www.ups.com/track?tracknum=${encodeURIComponent(n)}` },
  { key: "TFM", label: "TFM Xpress", url: (n) => `https://www.tfmxpress.com.au/track-trace/?id=${encodeURIComponent(n)}` },
  { key: "Other", label: "Other courier", url: (n) => `https://t.17track.net/en#nums=${encodeURIComponent(n)}` },
];

export const carrierLabel = (key) => (CARRIERS.find((c) => c.key === key)?.label) || key || "";

export function trackingUrl(carrier, number) {
  const n = (number || "").trim();
  if (!n) return null;
  const c = CARRIERS.find((x) => x.key === carrier);
  return c ? c.url(n) : `https://t.17track.net/en#nums=${encodeURIComponent(n)}`;
}
